
var sprite = require("/data/jenkins/jobs/deploy_web_common_h5_pipeline/workspace/fe-h5/smart-form/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"left\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Operation Icons Copy 4</title><defs><path id=\"left_a\" d=\"M-129-845h24v24h-24z\"/></defs><clipPath id=\"left_b\"><use xlink:href=\"#left_a\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#left_b)\"><defs><path id=\"left_c\" d=\"M-903-949H947V996H-903z\"/></defs><clipPath id=\"left_d\"><use xlink:href=\"#left_c\" overflow=\"visible\"/></clipPath></g><path d=\"M16.247 21.399L28.48 9.166l2.121 2.121-10.118 10.119 10.118 10.118-2.121 2.121-12.233-12.233.007-.006z\"/></symbol>";
module.exports = sprite.add(image, "left");


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/icon/style/assets/left.svg
// module id = 495
// module chunks = 0 1